export default "__VITE_ASSET__BdaSHpW1__"